export class ListItem {
    id: String;
    text: String;
    checked: boolean

    public constructor(source: any) {
      if (typeof source === 'string') {
        this.id = this.text = source;
      }
      if (typeof source === 'object') {
        this.id = source.id;
        this.text = source.text;
      }
    }
}
